// Common formatting utilities used across components

// Format price for display (e.g., $100000 -> $100K)
export const formatPrice = (value) => {
  if (!value || value === "-") return "-";
  const numValue = parseFloat(value.toString().replace(/[$,]/g, ""));
  if (isNaN(numValue)) return "-";
  if (numValue >= 1000000) return `$${(numValue / 1000000).toFixed(1)}M`;
  return `$${(numValue / 1000).toFixed(0)}K`;
};

// Format interest rate for display (e.g., 0.05 -> 5.0%)
export const formatInterestRate = (value) => {
  if (!value || value === "-") return "-";
  const numValue = parseFloat(value);
  if (isNaN(numValue)) return "-";
  return `${(numValue * 100).toFixed(1)}%`;
};

// Format price change for display (e.g., 5000 -> +$5K)
export const formatPriceChange = (value) => {
  if (!value || value === "-") return "-";
  const numValue = parseFloat(value.toString().replace(/[$,]/g, ""));
  if (isNaN(numValue)) return "-";
  const sign = numValue > 0 ? "+" : "";
  return `${sign}$${Math.abs(numValue).toLocaleString()}`;
};

// Format currency values
export const formatCurrency = (value) => {
  if (!value || value === "-") return "-";
  const numValue = parseFloat(value.toString().replace(/[$,]/g, ""));
  if (isNaN(numValue)) return "-";
  return `$${numValue.toLocaleString()}`;
};

// Format phone number (e.g., 1234567 -> 123-4567)
export const formatPhoneNumber = (value) => {
  if (!value) return "";
  const cleanValue = value.replace(/[^0-9]/g, "");
  if (cleanValue.length > 7) return cleanValue.slice(0, 7);
  if (cleanValue.length > 3) {
    return `${cleanValue.slice(0, 3)}-${cleanValue.slice(3)}`;
  }
  return cleanValue;
}; 